import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { PRODUCT_IMAGE } from '../../data/content';
const badges = ['6 Clinical Volumes', '5 Exclusive Bonuses', '100% Digital'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 px-5 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-139" data-mp="cujm2fp5lq1t">
      <div className="mx-auto flex w-full max-w-xl flex-col items-center text-center lg:max-w-3xl" data-id="element-140" data-mp="hsus0fcbvger">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.32em] text-teal-400" data-id="element-141" data-mp="mrxxu204tqns">
          Dr. Karito
        </p>

        <h1 className="mt-5 font-display text-[30px] font-bold leading-[1.12] text-white sm:text-[42px] lg:text-[52px]" data-id="element-142" data-mp="vmm4nwlcvgep">
          Solve the diagnosis and treatment of male infertility with a{' '}
          <em className="not-italic text-teal-400" data-id="element-143" data-mp="15ks487jowage">clear clinical route</em>
        </h1>

        <p className="mt-5 max-w-md text-[15px] leading-relaxed text-white/65 sm:text-lg lg:max-w-xl" data-id="element-144" data-mp="1ajmkp2u6pmxc">
          Stop improvising when faced with an abnormal semen analysis and become the professional who
          always knows what the next clinical step should be.
        </p>

        <div className="mt-8 w-full" data-id="element-145" data-mp="4qsspjr73aoo">
          <img src={PRODUCT_IMAGE} alt="Male Fertility Route: 6 digital clinical volumes and 5 bonuses shown on desktop, tablet and mobile" className="mx-auto w-full max-w-[420px] lg:max-w-[560px]" loading="eager" data-id="element-146" data-mp="3vuhgczmmv1pv" />
        </div>

        <p className="mt-6 text-[13px] font-semibold uppercase tracking-[0.1em] text-teal-300" data-id="element-147" data-mp="nfhahwudszw8">
          Male Fertility Route: 6 Digital Volumes + 5 Clinical Bonuses
        </p>

        <div className="mt-5 w-full max-w-md" data-id="element-148" data-mp="im4m9ntm6v40">
          <CTAButton id="hero-cta" label="I want the Male Fertility Route" data-id="element-149" data-mp="eluimhtaogsb" />
          <p className="mt-3 text-[11px] font-medium leading-relaxed text-white/50 sm:text-xs" data-id="element-150" data-mp="1b4jtb80r4ysb">
            Immediate download · One-time payment · Lifetime access · 7-day guarantee
          </p>
        </div>

        <ul className="mt-7 flex w-full flex-col items-stretch gap-2 sm:flex-row sm:justify-center" data-id="element-151" data-mp="30lnn8la5g1qh">
          {badges.map(badge => <li key={badge} className="flex items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2 text-[12px] font-semibold text-white/75 sm:text-[13px]" data-id="element-152" data-mp="35k8omo150rgi">
              <CheckIcon className="h-4 w-4 shrink-0 text-teal-400" aria-hidden="true" data-id="element-153" data-mp="2hvfrwpcoyfku" />
              {badge}
            </li>)}
        </ul>

        <p className="mt-7 max-w-md text-[13px] leading-relaxed text-white/45" data-id="element-154" data-mp="2mw3pxuzc7wok">
          More than 1,000 healthcare professionals already trust Dr. Karito.
        </p>
      </div>
    </header>;
}